import { TmBaseError } from '@/core/error/tmBaseError'

export class TmTitlerError extends TmBaseError {
  public name = 'TmTitlerError'
}
